import React from "react"
import {
  FormControl,
  ControlLabel,
  Modal,
  Button,
  FormGroup,
} from "react-bootstrap"
import FieldGroup from "../fragments/FieldGroup"
import ProcessesStatus from "../fragments/ProcessesStatus"
import CountryCodes from "./CountryCodes"

const LOAN_MIN_AGE = 10,
LOAN_MAX_AGE = 150

class AgeModalForm extends React.Component {

  state = {
    error: '',
    countryCodeValidate: null,
    minAgeValidate: null,
    maxAgeValidate: null,
  }

  //////////////////////////////////////////////////////////////////////
  //
  // Validators
  //
  /////////////////////////////////////////////////////////////////////

  getCountryCodeValidationState = countryCode =>
    (countryCode === 'default' || CountryCodes[countryCode]) ? 'success' : 'error'

  validateMinMaxAge = age => {
    const minAge = Number(age)
    if(minAge < LOAN_MIN_AGE || minAge > LOAN_MAX_AGE) return 'error'
    return 'success'
  }

  getMinAgeValidationState = min => this.validateMinMaxAge(min)

  getMaxAgeValidationState = (min, max) => 
    (max && Number(min) > Number(max)) ? 'error' : this.validateMinMaxAge(max)

  valid = () => {
    const { countryCode, min, max } = this.props
    return (
      this.getCountryCodeValidationState(countryCode) === 'success' &&
      this.getMinAgeValidationState(min) === 'success' &&
      this.getMaxAgeValidationState(min, max) === 'success'
    )
  }

  /**
   * Save on the server
   */
  saveAgeSetting = () => {

    this.setState({ error: null })

    const { saveAgeSetting, countryCode, min, max } = this.props

    if(this.valid()) {
      saveAgeSetting({ countryCode, min, max })
    }
    else {
      this.setState({
        error: 'Some fields are incorrect.',
        countryCodeValidate: this.getCountryCodeValidationState(countryCode),
        minAgeValidate: this.getMinAgeValidationState(min),
        maxAgeValidate: this.getMaxAgeValidationState(min, max)
      })
    }
  }

  countryCodeChanged = value => {
    const { setCountryCode } = this.props
    setCountryCode(value)
    this.setState({ countryCodeValidate: this.getCountryCodeValidationState(value) })
  }

  minAgeChanged = value => {
    const { setMin, max } = this.props
    setMin(value)
    this.setState({ 
      minAgeValidate: this.getMinAgeValidationState(value),
      maxAgeValidate: this.getMaxAgeValidationState(value, max)
    })
  }

  maxAgeChanged = value => {
    const { setMax, min } = this.props
    setMax(value)
    this.setState({ maxAgeValidate: this.getMaxAgeValidationState(min, value) })
  }

  renderCountries = () => {

    let data = [],
    sortedCountry = []

    for(let countryCode in CountryCodes) {
      sortedCountry.push([countryCode, CountryCodes[countryCode]])
    }

    sortedCountry.sort((a, b) => a[1].localeCompare(b[1]))
    sortedCountry.forEach(item => {
      data.push((
        <option key={item[0]} value={item[0]}>{item[1]}</option>
      ))
    })

    return data
  }

  render() {
    const { countryCodeValidate, minAgeValidate, maxAgeValidate,
      error: localError } = this.state,
    { show, handleClose, isUpdate, title, countryCode, min, max, error,
      running, success, buttonText } = this.props

    return (
      <Modal show={ show } onHide={ handleClose } >

        <Modal.Header closeButton>
          <Modal.Title>{ title }</Modal.Title>
        </Modal.Header>

        <Modal.Body>

          <FormGroup controlId='countryCode' validationState={ countryCodeValidate }>
            <ControlLabel>Country</ControlLabel>
            <FormControl componentClass="select" placeholder="select"
              value={ countryCode }
              onChange={e => this.countryCodeChanged(e.target.value) }
              disabled={ isUpdate }
              >
              <option value=""></option>
              <option key='default' value="default">Default</option>
              { this.renderCountries() }
            </FormControl>
          </FormGroup>

          <FieldGroup
            id="min"
            type="number"
            label="Min Age"
            placeholder="The min age"
            min={ LOAN_MIN_AGE }
            max={ LOAN_MAX_AGE }
            validationState={ minAgeValidate }
            value={ min }
            onChange={e => this.minAgeChanged(e.target.value) }
          />

          <FieldGroup
            id="max"
            type="number"
            label="Max age"
            placeholder="The max age"
            min={ LOAN_MIN_AGE }
            max={ LOAN_MAX_AGE }
            validationState={ maxAgeValidate }
            value={ max }
            onChange={e => this.maxAgeChanged(e.target.value) }
          />

          <ProcessesStatus
            error={ localError ? localError : error ? error : null }
            running={ running }
            success={ success }
          />
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={ handleClose }>Close</Button>
          <Button onClick={ this.saveAgeSetting } bsStyle="primary" disabled={ running }>
            { buttonText }
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

export default AgeModalForm



// WEBPACK FOOTER //
// ./src/components/Settings/AgeModalForm.js